export enum Cookie {
  QRSession = "QR-Session",
  QRSessionUser = "QR-Session-User",
  SentReasonForLeaving = "sent_reason_for_leaving",
  Locale = "locale",
  Accepted = "cookieAceito",
}

/**
 * Retorna o valor de um cookie específico baseado no nome passado
 * @param cookieKey Chave do cookie
 * @returns Valor do cookie buscado
 */
export function getCookieByKey(cookieKey: Cookie) {
  const allCookies = document.cookie;
  const cookie = allCookies
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${cookieKey}=`));
  return cookie ? cookie.substring(cookieKey.length + 1) : null;
}

/**
 * Define o valor de um cookie específico com chave e valor
 * @param key Chave do cookie
 * @param value Valor do cookie
 * @param days Quantidade de dias de validade do cookie
 */
export function setCookie(key: Cookie, value: string, days?: number) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  const hostname = window.location.hostname;
  const isQrpoint = hostname.endsWith("qrpoint.com.br");

  const domain = isQrpoint ? "; domain=.qrpoint.com.br" : "";
  const secure = window.location.protocol === "https:" ? "; Secure" : "";

  document.cookie = `${key}=${value}${expires}; path=/${domain}${secure}; SameSite=Lax`;
}
